// Same status badge pattern as the driver app — small colored pill
// showing a load or vehicle's current status. Centralizing the color
// logic here means new statuses only need to be added in one place.
function StatusBadge({ status }) {
  const statusConfig = {
    awaiting: { label: 'Awaiting', bg: '#fef3c7', color: '#92400e' },
    'picked up': { label: 'Picked Up', bg: '#dbeafe', color: '#1e40af' },
    delivered: { label: 'Delivered', bg: '#d1fae5', color: '#065f46' },
    canceled: { label: 'Canceled', bg: '#fee2e2', color: '#991b1b' },
  };

  const config = statusConfig[status] || statusConfig['awaiting'];

  return (
    <span
      style={{
        backgroundColor: config.bg,
        color: config.color,
        fontSize: 11,
        fontWeight: 700,
        padding: '3px 10px',
        borderRadius: 999,
        whiteSpace: 'nowrap',
      }}
    >
      {config.label}
    </span>
  );
}

export default StatusBadge;
